<script>
  import OptionAreaSection from '../EditorV2Pages/OptionAreaSection.svelte';
  import { useEditorV2Setup } from '../EditorV2Pages/setup.js';
  useEditorV2Setup();
</script>

<OptionAreaSection />